import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "grid gap-4 md:grid-cols-2" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "mt-5 flex flex-wrap gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiPageHero = _resolveComponent("UiPageHero")!
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiSelect = _resolveComponent("UiSelect")!
  const _component_UiCheckbox = _resolveComponent("UiCheckbox")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_UiPageHero, {
      eyebrow: "Tài khoản",
      title: "Cập nhật tài khoản",
      description: "Điều chỉnh thông tin, phân quyền hoặc khóa tài khoản."
    }),
    _createElementVNode("form", {
      class: "panel-pad max-w-4xl",
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($setup.save && $setup.save(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_UiInput, {
          modelValue: $setup.user.username,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.user.username) = $event)),
          label: "Tên đăng nhập"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_UiInput, {
          modelValue: $setup.user.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.user.password) = $event)),
          label: "Mật khẩu mới",
          type: "password",
          placeholder: "Để trống nếu không đổi"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_UiInput, {
          modelValue: $setup.user.fullname,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.user.fullname) = $event)),
          label: "Họ tên"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_UiInput, {
          modelValue: $setup.user.phoneNumber,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.user.phoneNumber) = $event)),
          label: "Số điện thoại"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_UiSelect, {
          modelValue: $setup.user.permission,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.user.permission) = $event)),
          label: "Quyền"
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createElementVNode("option", { value: "user" }, "Người dùng", -1),
            _createElementVNode("option", { value: "admin" }, "Quản trị viên", -1)
          ]))]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_UiSelect, {
          modelValue: $setup.user.idKhoaPhong,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.user.idKhoaPhong) = $event)),
          modelModifiers: { number: true },
          label: "Khoa/phòng"
        }, {
          default: _withCtx(() => [
            _cache[9] || (_cache[9] = _createElementVNode("option", { value: 0 }, "Chọn khoa/phòng", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.khoaPhong, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item.id,
                value: item.id
              }, _toDisplayString(item.tenKhoaPhong), 9, _hoisted_3))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_UiCheckbox, {
          modelValue: $setup.user.active,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.user.active) = $event))
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode(" Tài khoản đang hoạt động ", -1)
          ]))]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_UiButton, {
          type: "submit",
          icon: "save",
          loading: $setup.loading,
          "loading-text": "Đang lưu..."
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode(" Lưu thay đổi ", -1)
          ]))]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_UiButton, {
          variant: "danger",
          icon: "delete",
          onClick: $setup.removeUser
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createTextVNode(" Xóa tài khoản ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_UiButton, {
          to: "/userlist",
          variant: "secondary",
          icon: "back"
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createTextVNode("Quay lại", -1)
          ]))]),
          _: 1
        })
      ])
    ], 32)
  ]))
}